export function initCookieYes() {
    // Function to prevent default scroll behavior and trigger CookieYes modal
    function preventScrollBehavior() {
        const links = document.querySelectorAll('a[href="#cookie-preference"]');
        links.forEach((link) => {
            link.addEventListener('click', function (e) {
                e.preventDefault(); // Prevent default scroll behavior
                CookieYes.showConsentSettings(); // Trigger CookieYes modal
            });
        });
    }

    // Function to hide the CookieYes banner initially
    function hideCookieYesBanner() {
        const banner = document.querySelector('.cky-consent-container');
        if (banner) {
            banner.style.display = 'none';
        }
    }

    // Function to show the CookieYes banner
    function showCookieYesBanner() {
        const banner = document.querySelector('.cky-consent-container');
        if (banner) {
            banner.style.display = '';
        }
    }

    // Initial call to prevent scroll behavior
    preventScrollBehavior();

    // Hide banner initially and set timeout to show it
    hideCookieYesBanner();
    setTimeout(showCookieYesBanner, 5000); // 5000ms = 5 seconds

    // MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            // Check if the added nodes contain CookieYes links
            mutation.addedNodes.forEach(function (node) {
                if (
                    node.nodeType === Node.ELEMENT_NODE &&
                    node.querySelector('a[href="#cookie-preference"]')
                ) {
                    preventScrollBehavior();
                }
                // Also hide the banner if it's newly added to the DOM
                if (
                    node.nodeType === Node.ELEMENT_NODE &&
                    node.classList &&
                    node.classList.contains('cky-consent-container')
                ) {
                    hideCookieYesBanner();
                    setTimeout(showCookieYesBanner, 5000);
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}
